/* Liquid Ice — PAGES-A behaviour (BUILD-PAGES 10.10.2026). Vanilla, no dependencies, loaded deferred by the li-ag-shop-* / li-ag-blog-* sections.
   Shop filter pills (?f=spray|wear) · draw-in of coded SVGs ([data-ag-draw] → .is-in) · cart page (qty / remove via /cart/change.js,
   re-render through the Section Rendering API whenever the drawer re-renders, so the WILLKOMMEN gift sync stays the single source)
   · article share button. */
(() => {
  if (window.__liPagesA) return; window.__liPagesA = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* draw-in */
  const draws = $$('[data-ag-draw]');
  if (draws.length) {
    if (reduce || !('IntersectionObserver' in window)) draws.forEach(el => el.classList.add('is-in'));
    else {
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: 0.3 });
      draws.forEach(el => io.observe(el));
    }
  }

  /* shop filter */
  const grid = $('[data-ags-grid]');
  if (grid) {
    const items = $$('.ags-grid__item', grid);
    const pills = $$('[data-ags-pills] [data-ags-f]');
    const empty = $('[data-ags-empty]');
    const apply = (f, scroll) => {
      let n = 0;
      items.forEach(it => { const fam = it.dataset.fam; const show = !f ? true : fam === f; it.hidden = !show; if (show && fam !== 'ways') n++; });
      pills.forEach(p => { const on = (p.dataset.agsF || '') === f; p.classList.toggle('is-active', on); p.setAttribute('aria-pressed', String(on)); });
      if (empty) empty.hidden = n > 0;
      try { const u = new URL(location.href); f ? u.searchParams.set('f', f) : u.searchParams.delete('f'); history.replaceState(null, '', u); } catch (e) {}
      if (scroll) grid.closest('section')?.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    };
    document.addEventListener('click', e => {
      const b = e.target.closest('[data-ags-f]'); if (!b) return;
      e.preventDefault(); apply(b.dataset.agsF || '', !b.closest('[data-ags-pills]'));
    });
    $$('[data-ags-jump]').forEach(a => a.addEventListener('click', e => {
      const t = $(a.getAttribute('href')); if (!t) return; e.preventDefault();
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }));
    let f0 = ''; try { f0 = new URL(location.href).searchParams.get('f') || ''; } catch (e) {}
    if (f0 === 'spray' || f0 === 'wear') apply(f0, false);
  }

  /* cart page */
  const cartRoot = () => $('[data-agc]');
  if (cartRoot()) {
    const sid = cartRoot().dataset.agc;
    let busy = false, pend = false, t;
    const render = async () => {
      if (busy) { pend = true; return; } busy = true;
      try {
        const r = await fetch(`${root}cart?section_id=${encodeURIComponent(sid)}`, { headers: { Accept: 'text/html' } });
        const html = await r.text(); const tmp = document.createElement('div'); tmp.innerHTML = html;
        const fresh = $('[data-agc]', tmp), cur = cartRoot();
        if (fresh && cur && fresh.innerHTML !== cur.innerHTML) { cur.innerHTML = fresh.innerHTML; bindBar(); }
      } catch (e) {} finally { busy = false; if (pend) { pend = false; render(); } }
    };
    /* phone checkout bar: visible only while the summary checkout button is below the viewport */
    let mio;
    const bindBar = () => {
      if (mio) mio.disconnect();
      const bar = $('[data-agc-mbar]'), btn = $('.agc-sum__btn'); if (!bar || !btn || !('IntersectionObserver' in window)) return;
      mio = new IntersectionObserver(([e]) => bar.classList.toggle('is-hidden', e.isIntersecting || e.boundingClientRect.top < 0));
      mio.observe(btn);
    };
    bindBar();
    const drawer = $('[data-li-drawer]');
    if (drawer) new MutationObserver(() => { clearTimeout(t); t = setTimeout(render, 120); }).observe(drawer, { childList: true });
    /* add buttons on the cart page itself: add without opening the drawer over the page (capture phase, before li-clone.js) */
    document.addEventListener('click', async e => {
      const a = e.target.closest('[data-agc] [data-li-add]'); if (!a) return;
      e.preventDefault(); e.stopPropagation(); a.setAttribute('aria-busy', 'true');
      try {
        await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(a.dataset.liAdd), quantity: 1 }] }) });
        if (window.LI && LI.refresh) await LI.refresh(false); else location.reload();
        render();
      } catch (err) { location.reload(); }
    }, true);
    document.addEventListener('click', async e => {
      const b = e.target.closest('[data-agc-qty]'); if (!b) return;
      e.preventDefault(); const line = b.closest('[data-agc-line]'); if (line) line.setAttribute('aria-busy', 'true');
      try {
        await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.dataset.agcQty, quantity: Number(b.dataset.q) }) });
        if (window.LI && LI.refresh) await LI.refresh(false); else location.reload();
        render();
      } catch (err) { location.reload(); }
    });
  }

  /* article share */
  $$('[data-agb-share]').forEach(b => b.addEventListener('click', async () => {
    const data = { title: document.title, url: location.href.split('#')[0] };
    try {
      if (navigator.share) { await navigator.share(data); return; }
      await navigator.clipboard.writeText(data.url);
      const l = b.querySelector('[data-agb-share-label]'); if (l) { const o = l.textContent; l.textContent = b.dataset.done || 'Link kopiert'; setTimeout(() => (l.textContent = o), 2000); }
    } catch (e) {}
  }));
})();
